import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Button } from '../button/button';
import { Dialog } from '../dialog/dialog';

interface Props {
  onClose: (wasUpdated: boolean) => void;
}

const GcpAdjustmentDialog = (props: Props) => {
  const { t } = useTranslation();
  return (
    <Dialog
      closeIcon={true}
      closeOnDimmerClick={true}
      useGoogleTranslate={true}
      width={500}
      onClose={() => props.onClose(false)}
    >
      {{
        header: t('geodataPage.actions.addGcp', { ns: 'cloudProcessing' }),
        content: (
          <Content>
            <Text topMargin={false}>
              {t('geodataPage.dialogs.gcpAdjustmentDialog.info', { ns: 'cloudProcessing' })}
            </Text>
            <Text topMargin={true}>
              {t('geodataPage.dialogs.gcpAdjustmentDialog.confirmation', { ns: 'cloudProcessing' })}
            </Text>
          </Content>
        ),
        footer: {
          right: (
            <>
              <Button color="primary" variant="contained" onClick={() => props.onClose(true)}>
                {t('continue', { ns: 'common' })}
              </Button>

              <Button variant="text" onClick={() => props.onClose(false)}>
                {t('close', { ns: 'common' })}
              </Button>
            </>
          ),
        },
      }}
    </Dialog>
  );
};

const Text = styled.span<{ topMargin?: boolean; bottomMargin?: boolean }>`
  display: block;

  strong {
    font-weight: 600;
  }

  margin-top: ${(props) => (props.topMargin ? '0.5em' : undefined)};
  margin-bottom: ${(props) => (props.bottomMargin ? '0.5em' : undefined)};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
`;

export { GcpAdjustmentDialog };
